/*
 * PrintoRich: Shopify Inbox chat launcher -> round "Priya" avatar, stacked exactly above
 * the WhatsApp button (same size, same vertical line, 2 mm gap). Works on every page,
 * mobile / tablet / desktop.
 *
 * - Position is measured from the WhatsApp button's real on-screen box, so it follows any
 *   offset (mobile toolbar, the fast-checkout Buy Now bar, safe areas) automatically.
 * - Keeps retrying (Shopify Chat often loads late), and re-applies if Shopify re-renders the
 *   button, so the default square "Chat" button never stays on screen.
 * - Until the avatar is applied the launcher is kept transparent (max 10 s), so the square
 *   button does not flash; after 10 s it is shown regardless, never hidden permanently.
 */
(function () {
  var AVATAR_URL = 'https://cdn.shopify.com/s/files/1/0992/7167/2115/files/chat_bot_2.png';
  var GAP_PX = 8;              // ~2 mm between the WhatsApp button and the chat avatar
  var root = document.documentElement;

  // Hide only the un-styled default launcher for a moment (no flash of the square "Chat" button).
  // Shopify's chat button now lives inside a nested <shopify-agent-runtime> and is exported as
  // part="activator", so it is styled with ::part() (applies instantly and survives re-renders).
  // Size / position come from CSS variables measured from the WhatsApp button (see layout()).
  var st = document.createElement('style');
  st.textContent =
    'html:not(.pr-chat-ready) shopify-chat{opacity:0 !important}' +
    'shopify-chat{translate:none !important;transition:opacity .2s}' +
    'shopify-chat::part(activator){' +
      'background:#fff url(' + AVATAR_URL + ') center/cover no-repeat !important;' +
      'border-radius:50% !important;border:2px solid #fff !important;box-sizing:border-box !important;' +
      'box-shadow:0 4px 14px rgba(0,0,0,.25) !important;padding:0 !important;overflow:hidden !important;' +
      'width:var(--pr-chat-size,56px) !important;height:var(--pr-chat-size,56px) !important;' +
      'min-width:var(--pr-chat-size,56px) !important;min-height:var(--pr-chat-size,56px) !important;' +
      'max-width:var(--pr-chat-size,56px) !important;max-height:var(--pr-chat-size,56px) !important;' +
      'position:fixed !important;left:auto !important;top:auto !important;margin:0 !important;transform:none !important;' +
      'right:var(--pr-chat-right,20px) !important;bottom:var(--pr-chat-bottom,84px) !important;' +
      'color:transparent !important;font-size:0 !important;line-height:0 !important;gap:0 !important}';
  (document.head || root).appendChild(st);
  setTimeout(function () { root.classList.add('pr-chat-ready'); }, 10000);

  function layout() {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var vw = root.clientWidth, vh = root.clientHeight;
    var wa = document.querySelector('.wa-float');
    var r = wa ? wa.getBoundingClientRect() : null;
    if (r && r.width) {
      return {
        mobile: mobile,
        size: Math.round(r.width),
        right: Math.max(0, Math.round(vw - r.right)),
        bottom: Math.round(vh - r.top + GAP_PX)
      };
    }
    // Fallback if the WhatsApp button is not on the page.
    return mobile ? { mobile: true, size: 48, right: 14, bottom: 14 + 48 + GAP_PX }
                  : { mobile: false, size: 56, right: 20, bottom: 20 + 56 + GAP_PX };
  }

  function imp(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

  function styleHost(chat, L) {
    imp(chat, 'position', 'fixed');
    imp(chat, 'left', 'auto');
    imp(chat, 'top', 'auto');
    imp(chat, 'bottom', L.bottom + 'px');
    imp(chat, 'margin', '0');
    imp(chat, 'z-index', '71');
    if (L.mobile) {
      // Host stays inside the phone screen so the opened chat window fits; the round
      // launcher itself is positioned separately below.
      imp(chat, 'right', '12px');
      imp(chat, 'width', 'calc(100vw - 24px)');
      imp(chat, 'max-width', 'calc(100vw - 24px)');
      imp(chat, 'height', 'auto');
      imp(chat, 'box-sizing', 'border-box');
    } else {
      chat.style.removeProperty('max-width');
      chat.style.removeProperty('box-sizing');
      imp(chat, 'right', L.right + 'px');
      imp(chat, 'width', L.size + 'px');
      imp(chat, 'height', L.size + 'px');
    }
  }

  function styleButton(btn, L) {
    var s = L.size + 'px';
    btn.style.backgroundImage = 'url(' + AVATAR_URL + ')';
    btn.style.backgroundSize = 'cover';
    btn.style.backgroundPosition = 'center';
    btn.style.backgroundRepeat = 'no-repeat';
    btn.style.backgroundColor = '#ffffff';
    btn.style.borderRadius = '50%';
    btn.style.width = s;
    btn.style.height = s;
    btn.style.minWidth = s;
    btn.style.minHeight = s;
    btn.style.maxWidth = s;
    btn.style.maxHeight = s;
    btn.style.padding = '0';
    btn.style.overflow = 'hidden';
    btn.style.border = '2px solid #ffffff';
    btn.style.boxSizing = 'border-box';
    btn.style.boxShadow = '0 4px 14px rgba(0,0,0,0.25)';
    btn.style.position = 'fixed';
    btn.style.right = L.right + 'px';
    btn.style.bottom = L.bottom + 'px';
    btn.style.left = 'auto';
    btn.style.top = 'auto';
    btn.style.transform = 'none';
    btn.style.margin = '0';
    Array.prototype.forEach.call(btn.children, function (child) { child.style.opacity = '0'; });
  }

  function collapseTeaser(sr) {
    ['[class*="label"]', '[class*="teaser"]', '[class*="prompt"]', '[class*="welcome"]', '[class*="message"]']
      .forEach(function (sel) {
        sr.querySelectorAll(sel).forEach(function (el) {
          if (!el.classList.contains('activator') && !el.closest('.activator') && !el.closest('[role="dialog"]')) {
            el.style.setProperty('display', 'none', 'important');
          }
        });
      });
  }

  // Find the launcher button through any number of nested shadow roots.
  function deepFind(node, depth) {
    if (!node || depth > 6) return null;
    var el = node.querySelector('[part~="activator"], .activator');
    if (el) return el;
    var all = node.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var found = deepFind(all[i].shadowRoot, depth + 1);
        if (found) return found;
      }
    }
    return null;
  }

  // Shopify's inner wrapper can act as the containing block for the "fixed" button, so after
  // placing it we measure where it really landed and correct right/bottom by the difference.
  var corrRight = 0, corrBottom = 0;
  function setVars(L) {
    root.style.setProperty('--pr-chat-size', L.size + 'px');
    root.style.setProperty('--pr-chat-right', (L.right + corrRight) + 'px');
    root.style.setProperty('--pr-chat-bottom', (L.bottom + corrBottom) + 'px');
  }
  function placed(L) { return { size: L.size, right: L.right + corrRight, bottom: L.bottom + corrBottom }; }

  var observed = null;
  function apply() {
    var L = layout();
    setVars(L);
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return;
    var sr = chat.shadowRoot;
    styleHost(chat, L);
    var btn = deepFind(sr, 0);
    if (btn) {
      styleButton(btn, placed(L));
      var r = btn.getBoundingClientRect();
      if (r.width) {
        var wantLeft = root.clientWidth - L.right - L.size;
        var wantTop = root.clientHeight - L.bottom - L.size;
        var dx = wantLeft - r.left, dy = wantTop - r.top;
        if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
          corrRight -= dx;      // larger right  -> moves left
          corrBottom -= dy;     // larger bottom -> moves up
          setVars(L);
          styleButton(btn, placed(L));
        }
      }
      root.classList.add('pr-chat-ready');
    }
    collapseTeaser(sr);
    if (observed !== sr && window.MutationObserver) {
      observed = sr;
      // childList only (not attributes) so our own style changes do not re-trigger this.
      new MutationObserver(function () { apply(); }).observe(sr, { childList: true, subtree: true });
    }
  }

  // Fast retries while the page settles, then a light background check forever.
  var started = Date.now();
  (function tick() {
    apply();
    setTimeout(tick, Date.now() - started < 20000 ? 400 : 2000);
  })();
  window.addEventListener('resize', function () { setTimeout(apply, 120); setTimeout(apply, 600); }, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(apply, 300); });
})();
